import { getInit } from "./InitModelFilter";
import ModelFilter from "./components/toyota/ModelFilter";

// Webpack entry point for ModelFilter Toyota.
export const init = getInit(ModelFilter);
